export const CartIconV2 = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 21C10.8023 21 11.25 20.5523 11.25 20C11.25 19.4477 10.8023 19 10.25 19C9.69772 19 9.25 19.4477 9.25 20C9.25 20.5523 9.69772 21 10.25 21Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.25 21C18.8023 21 19.25 20.5523 19.25 20C19.25 19.4477 18.8023 19 18.25 19C17.6977 19 17.25 19.4477 17.25 20C17.25 20.5523 17.6977 21 18.25 21Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 3H5.75C5.75 3 6.16294 4.82843 6.42753 6C6.95622 8.34099 7.68235 11.5562 8.10836 13.4425C8.3143 14.3543 9.12398 15 10.0588 15H18.6457C19.5831 15 20.3947 14.3489 20.598 13.4339L22.25 6"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 6H6.75"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
